Ext.ns('mx.state');

mx.state.GridCookieProvider = Ext.extend(Ext.state.CookieProvider, {
    get: function(name, defaultValue) {
        return mx.state.GridCookieProvider.superclass.get.call(this, ur + '-' + name, defaultValue);
    },
    set: function(name, value) {
        mx.state.GridCookieProvider.superclass.set.call(this, ur + '-' + name, value);
    },
});
